import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const FinanceApprovalListing = ({
  fetchApprovedRejectedList,
  fetchApproveRejectListForFinance = {}
}) => {
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    if (fetchApprovedRejectedList !== null) {
      (async () => {
        setIsLoading(true);
        await fetchApprovedRejectedList();
        setIsLoading(false);
      })();
    }
  }, [fetchApprovedRejectedList]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    // console.log(filterData.site_no);
    setFilterData(filterData);
    await fetchApprovedRejectedList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
            onClick={filterToggle}
            className="filter-hamburger filter-btn btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
    </Fragment>
    );
  };

  const Headers = [
    'Site No',
    'Site Name',
    'Requested By',
    'Requested Status',
    'Remark',
    'Requested On',
    'Status'
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'site_name',
      'name',
      'statusName',
      'remark',
      'created_at',
      'status'
    ];

    console.log("Testing:", fetchApproveRejectListForFinance.per_page)

    if (fetchApproveRejectListForFinance.data) {
      const data = fetchApproveRejectListForFinance.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
              {
                // 'Approve/Reject': '',
               
              }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(fetchApproveRejectListForFinance.total / fetchApproveRejectListForFinance.per_page));
    }
  }, [fetchApproveRejectListForFinance]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchApprovedRejectedList(filterData, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout title={'Approved/Rejected List'} isLoading={isLoading} Buttons={headerBtns}>
      <TableSection
        data={listData}
        headers={Headers}
        detailList={fetchApproveRejectListForFinance && fetchApproveRejectListForFinance.resultSets}
        // onChange={(data) => updateApproval(data)}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isId={false}
        srNo={fetchApproveRejectListForFinance?.from}
      />

      <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          siteApprovalFinance={true}
      />
    </Layout>
  );
};

FinanceApprovalListing.propTypes = {
  fetchApproveRejectListForFinance: PropTypes.any,
};

export default FinanceApprovalListing;
